export default "/images/74e0b133af73c276463a91860f717cc0.jpg";